import { render } from "./WCCartDrawerOrderType.vue?vue&type=template&id=b4377db4&scoped=true"
import script from "./WCCartDrawerOrderType.vue?vue&type=script&lang=js"
export * from "./WCCartDrawerOrderType.vue?vue&type=script&lang=js"

import "./WCCartDrawerOrderType.vue?vue&type=style&index=0&id=b4377db4&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b4377db4"]])

export default __exports__